/* FLÁYR – productkaart: op touchscreens 1x naar links vegen toont de tweede foto, terugvegen de eerste.
   Daarna (of in de andere richting) scrollt de slider gewoon zoals normaal. */
(function () {
  if (window.flayrCardSwipe) return;
  window.flayrCardSwipe = true;

  var state = null;

  function reset() {
    if (state && state.media) {
      state.media.classList.remove('is-flayr-dragging');
      state.media.style.removeProperty('--flayr-drag');
    }
    state = null;
  }

  document.addEventListener('touchstart', function (e) {
    var media = e.target.closest('.product-card__media');
    if (!media || e.touches.length > 1 || !media.querySelector('.product-card__image--secondary')) {
      state = null;
      return;
    }
    /* Tweede foto alvast laden zodra de kaart wordt aangeraakt */
    var secondary = media.querySelector('.product-card__image--secondary');
    if (secondary.loading === 'lazy') secondary.loading = 'eager';
    state = { media: media, x: e.touches[0].clientX, y: e.touches[0].clientY, dir: null, width: media.offsetWidth };
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!state) return;
    var dx = e.touches[0].clientX - state.x;
    var dy = e.touches[0].clientY - state.y;

    if (state.dir === null) {
      if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
      var onSecond = state.media.classList.contains('is-flayr-second');
      if (Math.abs(dx) > Math.abs(dy) && ((dx < 0 && !onSecond) || (dx > 0 && onSecond))) {
        state.dir = dx < 0 ? 'next' : 'prev';
        state.media.classList.add('is-flayr-dragging');
      } else {
        state = null;
        return;
      }
    }

    if (e.cancelable) e.preventDefault();
    var drag = state.dir === 'next' ? Math.max(-state.width, Math.min(0, dx)) : Math.min(state.width, Math.max(0, dx));
    state.media.style.setProperty('--flayr-drag', drag + 'px');
  }, { passive: false });

  document.addEventListener('touchend', function (e) {
    if (!state || !state.dir) {
      state = null;
      return;
    }
    var dx = e.changedTouches[0].clientX - state.x;
    var media = state.media;
    if (Math.abs(dx) > Math.min(40, state.width * 0.2)) {
      media.classList.toggle('is-flayr-second', state.dir === 'next');
    }
    media.dataset.flayrSwiped = String(Date.now());
    reset();
  }, { passive: true });

  document.addEventListener('touchcancel', reset, { passive: true });

  /* Geen productpagina openen als iemand net geveegd heeft */
  document.addEventListener('click', function (e) {
    var media = e.target.closest('.product-card__media');
    if (media && media.dataset.flayrSwiped && Date.now() - Number(media.dataset.flayrSwiped) < 400) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
})();
